<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <div class="dashboard-wrapper pb-5">

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  اعلان ها
                </div>
                <span>
                  <button v-if="Object.keys(state_notifications).length" class="ar-btn size-md primary" @click="deleteNotification(0)">حذف همه</button>
                </span>
              </div>
              <div class="ar-card-body">
                <div v-if="!Object.keys(state_notifications).length" class="text-center my-3 text-muted">هیچ اعلانی وجود ندارد.</div>
                  <div v-for="(notification , key) in state_notifications" :key="key" class="alert m-2" :class="[notification.color]">
                    <div class="float-left mt-2">
                      <!-- <template v-if="notification.has_link">
                        <router-link
                          class="btn-notlink btn-sm btn" :class="['btn-'+notification.color]"
                          :to="{name:notification.section , params:{id:notification.model_id}}">
                          بررسی کردن
                        </router-link>
                      </template> -->

                      <i @click="deleteNotification(notification.id)" class="fa fa-times"></i>

                    </div>
                  <div><small v-if="notification.title" class="alert-heading">{{notification.title}}</small></div>
                  {{notification.text}}

                  </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import {io} from 'socket.io-client';
export default {
  name: 'Notifications',
  components:{
    Sidebar,
    Header,
  },
  data : () => ({
    loading:false,
    items:{},
    socket : null,
  }),
  methods:{
    notifications(){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.get(`notifications`,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.StoreNotifications(res.data.data.list)
        this.notificationCount(res.data.data.count)
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });
      
    },
    deleteNotification(id){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.get(`notificationDelete/`+id,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( () => {
        this.notifications();
      })
      .catch( () => {
        this.activeLoading(false)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
    this.socket = io(this.socketUrl);
    this.checkAuth()
  }
}
</script>
<style>
</style>